"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RelativeRangePicker = void 0;
var tslib_1 = require("tslib");
// (C) 2019 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var DynamicSelect_1 = require("../DynamicSelect/DynamicSelect");
var utils_1 = require("../DynamicSelect/utils");
var react_intl_1 = require("react-intl");
var VirtualizedSelectMenu_1 = require("../Select/VirtualizedSelectMenu");
var RelativeRangePickerComponent = /** @class */ (function (_super) {
    tslib_1.__extends(RelativeRangePickerComponent, _super);
    function RelativeRangePickerComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.toFieldRef = react_1.default.createRef();
        _this.isTouchDevice = function () {
            return "ontouchstart" in window || navigator.msMaxTouchPoints;
        };
        _this.focusToField = function () {
            var isTouchDevice = _this.isTouchDevice();
            if (_this.toFieldRef.current) {
                /**
                 * Prevents hover style from persisting after switching to another field on
                 * touchscreen devices.
                 */
                isTouchDevice
                    ? setTimeout(function () {
                        _this.toFieldRef.current.focus();
                    }, 0)
                    : _this.toFieldRef.current.focus();
            }
        };
        _this.blurToField = function () {
            var isTouchDevice = _this.isTouchDevice();
            if (_this.toFieldRef.current) {
                isTouchDevice
                    ? setTimeout(function () {
                        _this.toFieldRef.current.blur();
                    }, 0)
                    : _this.toFieldRef.current.blur();
            }
        };
        _this.handleFromChange = function (from) {
            _this.props.onSelectedFilterOptionChange(tslib_1.__assign(tslib_1.__assign({}, _this.props.selectedFilterOption), { from: from }));
            if (from !== undefined) {
                _this.focusToField();
            }
        };
        _this.handleToChange = function (to) {
            _this.props.onSelectedFilterOptionChange(tslib_1.__assign(tslib_1.__assign({}, _this.props.selectedFilterOption), { to: to }));
            _this.blurToField();
        };
        return _this;
    }
    RelativeRangePickerComponent.prototype.render = function () {
        var _a = this, handleFromChange = _a.handleFromChange, handleToChange = _a.handleToChange;
        var _b = this.props, selectedFilterOption = _b.selectedFilterOption, intl = _b.intl, isMobile = _b.isMobile;
        var mobileVisibleItemsRange = 5;
        var commonProps = {
            visibleItemsRange: isMobile ? mobileVisibleItemsRange : VirtualizedSelectMenu_1.defaultVisibleItemsRange,
            optionClassName: "s-relative-date-filter-option s-do-not-close-dropdown-on-click",
            getItems: function (value) {
                var items = utils_1.getRelativeDateFilterItems(value, selectedFilterOption.granularity, intl);
                // separators are not needed in mobile as all the items have borders
                return isMobile ? items.filter(function (item) { return item.type !== "separator"; }) : items;
            },
        };
        return (react_1.default.createElement("div", { className: "gd-relative-range-picker s-relative-range-picker" },
            react_1.default.createElement(DynamicSelect_1.DynamicSelect, tslib_1.__assign({ value: selectedFilterOption.from, onChange: handleFromChange, placeholder: intl.formatMessage({ id: "filters.from" }), className: classnames_1.default("gd-relative-range-picker-picker", "s-relative-range-picker-from", isMobile && "gd-relative-range-picker-picker-mobile") }, commonProps)),
            react_1.default.createElement("span", { className: "gd-relative-range-picker-dash" }, "\u2014"),
            react_1.default.createElement(DynamicSelect_1.DynamicSelect, tslib_1.__assign({ value: selectedFilterOption.to, onChange: handleToChange, placeholder: intl.formatMessage({ id: "filters.to" }), className: classnames_1.default("gd-relative-range-picker-picker", "s-relative-range-picker-to", isMobile && "gd-relative-range-picker-picker-mobile") }, commonProps, { ref: this.toFieldRef }))));
    };
    return RelativeRangePickerComponent;
}(react_1.default.Component));
exports.RelativeRangePicker = react_intl_1.injectIntl(RelativeRangePickerComponent);
//# sourceMappingURL=RelativeRangePicker.js.map